import { AppContextType, CategoryHierarchyType, LocationType, ProfileType, ThemeEnum } from 'types';

// initial value of the global state in
export const globalContextInitialValue: (
    theme: ThemeEnum,
    profile?: ProfileType<'detail'>,
    locations?: LocationType<'list'>[],
    parentLocations?: LocationType<'list'>[],
    categories?: CategoryHierarchyType[],
) => AppContextType = (theme, profile, locations, parentLocations, categories) => ({
    update: (...e) => {
        return 'this one is going to change in container.tsx' + e.length;
    },
    theme,
    profile,
    locations: locations,
    parentLocations: parentLocations,
    categories: categories,
});
